import React, {useEffect} from 'react';
import {DefaultFiltersPros} from '@pluto/@types';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import wrap from 'wraptile';
import ContentPartners from './ContentPartners';

export interface ContentPartnersContainerProps extends DefaultFiltersPros {
    setContentPartners: () => void;
    contentPartners: {
        data: {
            rows: [{ label: string, value: string }],
        }
        isLoading: boolean,
    };
}

export const onEffect = wrap((setContentPartners: any, {isLoading}:any) => {
    if (isLoading)
        setContentPartners();
});

const mapRowsToOptions = ({value, label}:any) => (
    <MenuItem
        key={value}
        value={value}
    >
        {label.toUpperCase()}
    </MenuItem>
);

export const getOptions = (data: any) => {
    if (!data) {
        return null;
    }

    return data.rows.map(mapRowsToOptions);
};

export const getInputLabel = (variant: string, placeholder: string) => {
    if (variant === 'outlined')
        return null;

    return (
        <InputLabel
            id="content-partners-label"
        >
            {placeholder}
        </InputLabel>
    );
};

export default function ContentPartnersContainer(props: ContentPartnersContainerProps) {
    const {
        setContentPartners,
        contentPartners,
        onChange,
        value,
        placeholder = 'CONTENT PARTNERS',
        variant = 'standard',
    } = props;

    const {
        isLoading,
        data,
    } = contentPartners;
    const fetchPartners = onEffect(setContentPartners, contentPartners);

    useEffect(fetchPartners, []);

    if (isLoading) {
        return <CircularProgress />;
    }

    const opts = getOptions(data);
    const inputLabel = getInputLabel(variant, placeholder);
    return (
        <ContentPartners
            inputLabel={inputLabel}
            value={value}
            onChange={onChange}
            variant={variant}
            opts={opts}
        />
    );
}
